/**
 * 사업자몰 리스트 모듈
 *
 * DIT 2.0
 *  - 같은 폴더 plpItem-VIO23.js 기반으로 작성
 *
 * @since 2023.10.23
 */
var plpItemB2b = (function () {
	"use strict";

	// 신제품
	// prettier-ignore
	var tempNew = '<div class="bnr_area {{_type}} type0{{models.length}}" {{#if _type == "emp"}}style="background-image: url(\'/lg5-common/images/UTS/banner-bg01-type02-{{_device}}.png\')"{{/if}}>' +
		'<div class="bnr_left">' +
			'{{#if _isFlag != ""}}<span class="lab_{{_isFlag}}">{{isFlag}}</span>{{/if}}' +
			'<span class="txt_b">{{#if _device == "mo"}}{{#raw title}}{{#else}}{{#raw titlePc}}{{/if}}</span>' +
			'<span class="txt_s">{{#if _device == "mo"}}{{#raw description}}{{#else}}{{#raw descriptionPc}}{{/if}}</span>' +
		'</div>' +
		'<div class="bnr_right">' +
			'{{#each item in models}}<a href="{{item.modelUrlPath}}" target="{{target}}"><div class="prod_box">' +
				'<img src="{{item._imageUrl}}" alt="{{item.imageAlt}}" class="lazyload">' +
				'{{#if _type != "emp"}}<div class="img_mask"></div>{{/if}}' +
				'<div class="bnr_pay">' +
					'<div class="name">'+
						'<span>'+
							'{{#raw item.modelDisplayName}}'+
						'</span>'+	
						'{{#if item._keywdNmText != ""}}<span class="add_tit">{{#raw item._keywdNmText}}</span>{{/if}}' +
						'{{#if item._keywdNmText1 != ""}}<span class="add_tit">{{#raw item._keywdNmText1}}</span>{{/if}}' +
					'</div>' +
					'<div class="model">{{item.modelName}}</div>' +
					'<div class="pay">' +
						'{{#if item._newSaleRate != 0 && item._newSaleRate > 4}}<span class="sale">{{vcui.number.addComma(item._newSaleRate)}}%</span>{{/if}}' +
						'{{#if item.price != "0"}}<span class="price">{{vcui.number.addComma(item.price)}}<span class="unit">원</span></span>{{/if}}' +
					'</div>' +
				'</div>' +
			'</div></a>{{/each}}' +
		'</div>' +
	'</div>';
	
	// 제품 - 탭 - 스펙
	// prettier-ignore
	var tempTabSpec =
		'<div id="prod_{{_id}}_{{#raw _index}}_tab1">' +
			'<div class="cnt-wrap type-tbl">' +
				'<div class="cnt_area">' +
					"{{#each item in techSpecs}}<dl><dt>{{item.SPEC_NAME}}</dt><dd>{{item.SPEC_VALUE_NAME}}</dd></dl>{{/each}}" +
				"</div>" +
				'<div class="btn_area">' + 
					'<a href="{{_modelUrlPath}}" class="btn search-btn" data-contents="{{#raw modelDisplayName}} {{#raw sku}}">제품 상세보기</a>' +
				"</div>" +
			"</div>" +
		"</div>";

	// 제품 - 탭 - 리뷰
	// prettier-ignore
	var tempTabReview = '<div id="prod_{{_id}}_{{#raw _index}}_tab2">' +
		'<div class="cnt-wrap type-lst">' +
			'<div class="cnt_area review">' +
				'<div class="review_score">' +
					'<span class="score_star">{{#raw reviewContent.score}}</span>' +
					'<span class="score_class">{{#raw reviewContent.scoreText}}</span>' +
					'<span class="score_rate"><em>{{#raw reviewContent.likePercent}}%</em>사용자가 이 제품을 좋아합니다.</span>' +
				'</div>' +
				'<div class="review_comment">' +
					'{{#if reviewContent.content}}<div class="comment_cnt">{{#raw reviewContent.content}}</div>{{/if}}' +
				'</div>' +
				'{{#if reviewContent.media && reviewContent.media.total > 0}}<div class="review_photo">' +
					'<div class="photo_tit">포토&amp;동영상 리뷰 총 <em>{{reviewContent.media.total}}</em>개 있습니다.</div>' +
					'<ul>{{#each item in reviewContent.media.assets}}' +
						'<li class="ui_bg_switch {{#if item.isVideo == "Y"}}review_vod{{/if}}" data-pc-src="{{item.thumbnail}}" data-m-src="{{item.thumbnail}}"></li>' +
					'{{/each}}</ul>' +
				'</div>{{/if}}' +
				'<div class="btn_area">' +
					'<a href="{{_modelUrlPath}}#pdp_review" class="btn search-btn" data-contents="{{#raw modelDisplayName}} {{#raw sku}}">리뷰 전체보기</a>' +
				'</div>' +
			'</div>' +
		'</div>' +
	'</div>';
	
	// 메뉴얼
	// prettier-ignore
	var tempManual = '<li>' +
		'<div class="sumore_tit">{{item.manual._title}}</div>' +
		'<div class="sumore_cnt">{{item.manual._desc}}</div>' +
		'<div class="sumore_infoarea">' +
			'<div class="sumore_info">' +
				'<div class="info_text">{{item.manual.language}}</div>' +
				'<div class="info_date">{{item.manual.date}}</div>' +
			'</div>' +
			'{{#if item.manual.file}}<div class="link_area">' +
				'{{#each file in item.manual.file}}<a href="{{file.src}}" data-contents="{{item.manual._title}}" data-type="{{file.type}}" class="ios_blank">{{file.type}}</a>{{/each}}' +
			'</div>{{/if}}' +
		'</div>' +
	'</li>';
	// 메뉴얼
	// prettier-ignore
	var tempDriver = '<li>' +
	    '<div class="sumore_tit {{#if item.mktModelCd}}sw{{/if}}">{{item.driver.title}}</div>' +
	    '<div class="sumore_infoarea">' +
	      '<div class="sumore_info {{#if !item.mktModelCd}}sw{{/if}}">' + 
	        '<div class="info_text">{{item.driver.category}}</div>' + 
	        '<div class="info_date">{{item.driver.date}}</div>' + 
	      '</div>' + 
	      '{{#if item.driver.file}}' +
	        '<div class="link_area {{#if !item.mktModelCd}}sw{{/if}}">' + 
	          '<a href="{{item.driver.file.src}}" data-contents="{{item.driver.title}}" class="ios_blank">다운로드 {{item.driver.file.size}}</a>' + 
	        '</div>' + 
	      '{{/if}}' +
	    '</div>' +
	  '</li>';

	// 제품 - 탭 - 고객지원
	// prettier-ignore
	var tempTabSupport = '<div id="prod_{{_id}}_{{#raw _index}}_tab3">' +
	    '<div class="cnt-wrap type-{{#if support.length > 1}}lst{{#else}}tbl{{/if}} {{#if support.length && support[0]._isOne}}one{{/if}}">' +
	      '<div class="cnt_area support">' +
	        '{{#if support.length == 1}}' + 
	          '{{#each item in support}}<ul>' +
	            '{{#if !item.manual.file && !item.driver.file}}' + // 1:n (전체보기 버튼형)
	              '{{#if item.manualCnt}}<li><button type="button" data-title="{{_titleText}}" data-unit="support" data-model="{{item.mktModelCd}}" data-href="#layerManualMore" data-control="modal" class="pdf">사용설명서 <span>{{item.manualCnt}}건</span></button></li>{{/if}}' +
	              '{{#if item.driverCnt}}<li><button type="button" data-title="{{_titleText}}" data-unit="support" data-model="{{item.mktModelCd}}" data-href="#layerDriverMore" data-control="modal" class="sw">드라이브 S/W <span>{{item.driverCnt}}건</span></button></li>{{/if}}' +
	            '{{#else}}' +  // 1:1 (즉시 다운로드)
	              '{{#if item.manual.file}}' +
	                tempManual +
	              '{{#elsif item.driver.file}}' + 
	                tempDriver +
	              '{{/if}}' +
	            '{{/if}}' +
	          '</ul>{{/each}}' +
	        '{{#else}}' +
	          '<ul>' +  // 묶음
	            '{{#each item in support}}<li>' + 
	            	'<div class="support-prod-info">'+
						'<img onerror="lgkorUI.addImgErrorEvent(this);" data-pc-src="{{item._imageUrl}}" data-m-src="{{item._imageUrl}}" alt="{{item._title}}" />' +
						'<div class="support_prod">' +
							'<span class="name">{{item._title}}</span>' +
							'<span class="model">{{item.mktModelCd}}</span>' +
						'</div>' +
					'</div>' +
					'<ul class="support_file">' +
						'{{#if item.manualCnt}}<li><button type="button" data-title="{{_titleText}}" data-unit="support" data-model="{{item.mktModelCd}}" data-href="#layerManualMore" data-control="modal" class="pdf">사용설명서 <span>{{item.manualCnt}}건</span></button></li>{{/if}}' +
						'{{#if item.driverCnt}}<li><button type="button" data-title="{{_titleText}}" data-unit="support" data-model="{{item.mktModelCd}}" data-href="#layerDriverMore" data-control="modal" class="sw">드라이브 S/W <span>{{item.driverCnt}}건</span></button></li>{{/if}}' +
					'</ul>' +
	            '</li>{{/each}}' +
	          '</ul>' +
	        '{{/if}}' +
	      '</div>' +
	  '</div>' +
	  '</div>';	

	// 제품 - 탭
	// prettier-ignore
	var tempProductItemTab = '<div class="result-tabs">' +
		'<div class="cnt_mo_default {{#if _hasReview}}is_review{{/if}}">' +
			'<span class="cnt_mo_txt spec">{{#raw _specsStr}}</span>' +
			'<span class="cnt_mo_txt review">{{#if _hasReview}}<span><em>고객 리뷰</em> {{#raw _reviewPreview}}% 사용자가 이 제품을 좋아합니다.</span>{{/if}}</span>' + // 리뷰
			'<span class="cnt_mo_txt">{{#raw _supportPreview}}</span>' +
			'<div class="tab_mo_mask"></div>' +
				'{{#if _hasReview}}' +
					'<div class="cnt_mo_review">' +
						'<div class="review_score">' +
							'<span class="score_star">{{#raw reviewContent.score}}</span>' +
							'<span class="score_class">{{#raw reviewContent.scoreText}}</span>' +
							'<span class="score_rate"><em>{{#raw reviewContent.likePercent}}%</em>사용자가 이 제품을 좋아합니다.</span>' +
						'</div>' +
					'</div>' +
				'{{/if}}' +
				'<a href="#n" class="cnt_mo_open" data-contents ="내용 더 보기 / {{#raw modelDisplayName}}/{{#raw sku}}/{{#raw _index}}">상세내용보기</a>' +
			'</div>' +
			'<div class="tabs-wrap border-type ui_tab" data-contents ="{{#raw modelDisplayName}}/{{#raw sku}}/{{#raw _index}}">' +
				'<ul class="tabs">' +
					'{{#if techSpecs.length}}<li><a href="#prod_{{_id}}_{{#raw _index}}_tab1">스펙</a></li>{{/if}}' +
					'{{#if _hasReview}}<li><a href="#prod_{{_id}}_{{#raw _index}}_tab2">리뷰</a></li>{{/if}}' +
					'{{#if _supportPreview.length}}<li><a href="#prod_{{_id}}_{{#raw _index}}_tab3">고객지원</a></li>{{/if}}' +
				'</ul>' +
				'<div class="tab_mo_mask"></div>' +
				'<a href="#n" class="tab_mo_close" data-contents="내용 닫기 / {{#raw modelDisplayName}} {{#raw sku}}">상세내용닫기</a>' +
			'</div>' +
			'<div class="tabs-contant">' +
				'{{#if techSpecs.length}}' + tempTabSpec + '{{/if}}' +
				'{{#if _hasReview}}' + tempTabReview + '{{/if}}' +
				'{{#if _supportPreview.length}}' + tempTabSupport + '{{/if}}' +
			'</div>' +
		'</div>';

	// 제품
	// prettier-ignore
	var tempProductItem = '<li>' + 
		'<div class="item" data-ec-product="{{ga}}" data-b2bcatemapping="{{b2bCateMapping}}" data-caretype="{{careType}}" data-id="{{modelId}}" data-lgecomOnlyFlag="{{_lgcomOnlyFlag}}">' +
			'<div class="result-top-area">' +
				'<div class="item_topright">' +
					'{{#if _compareBtnState}}<div class="compare_check">' +
						'<span class="chk-wrap">' +
							'<input type="checkbox" id="prodcompare_chk_{{#raw _index}}" name="prodcompare_chk_{{#raw _index}}" data-id="{{modelId}}" data-contents="{{#raw modelDisplayName}}">' +
							'<label for="prodcompare_chk_{{#raw _index}}">비교하기</label>' +
						'</span>' +
					'</div>{{/if}}' +
				'</div>' +
			'</div>' +
			'<div class="result-thumb">' +
				'<a href="{{_pdpUrlPath}}" data-contents="{{#raw modelDisplayName}} {{#raw sku}}"><img onError="lgkorUI.addImgCateErrorEvent(this, \'{{noImageUrl}}\');" data-m-src="{{_imageUrl}}" data-pc-src="{{_imageUrl}}" alt="{{imageAlt}}"></a>' +
				'{{#if (modelStatusCode == "ACTIVE" || modelStatusCode == "SOLD_OUT" || modelStatusCode == "READY_FOR_SALE") && _lgcomOnlyFlag == "Y"}}' +
					'<span class="lge-only"><em class="blind">닷컴 ONLY</em></span>' +
				'{{/if}}'+
			'</div>' +
			'<div class="result-info">' +
				'<div class="info-text">' +
					'<div class="detail-wrap">' +
						'<div class="badge_box">' +
							'{{#if modelStatusCode == "READY_FOR_SALE"}}<span class="prod_badge to_be_sold">판매예정</span>{{/if}}' +
							'{{#if newYearTextBadge != ""}}<span class="prod_badge release23">{{newYearTextBadge}}</span>{{/if}}' +
							'{{#if couponFlag == "Y"}}<span class="prod_badge">쿠폰</span>{{/if}}' +
							'{{#if pointFlag == "Y"}}<span class="prod_badge">포인트</span>{{/if}}' +
							'{{#if giftFlag == "Y"}}<span class="prod_badge">사은품</span>{{/if}}' +
						'</div>' + 
						'<div class="result-tit"><a href="{{_pdpUrlPath}}" data-contents="{{#raw modelDisplayName}} {{#raw sku}}">' +
								'<span>{{#raw title}}</span>' +
								'{{#if _keywdNmText != ""}}<span class="add_tit">{{#raw _keywdNmText}}</span>{{/if}}' +
								'{{#if _keywdNmText1 != ""}}<span class="add_tit">{{#raw _keywdNmText1}}</span>{{/if}}' +
							'</a>'+
						'</div>' +
						'<div class="result-detail">' +
							'<div class="sku">{{#raw sku}}</div>' +
							'{{#if review > 0}}'+
								'<div class="review-info">' +
									'<a href="javascript:void(0)">'+
										'<div class="star is-review"><span class="blind">리뷰있음</span></div>' +
										'<div class="average-rating"><span class="blind">평점</span>{{#raw rating}}</div>' +
										'<div class="review-count"><span class="blind">리뷰 수</span>({{#raw review}})</div>' + 
									'</a>'+
								'</div>'+
							'{{/if}}' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div class="info-price">' +
				'{{#if (modelStatusCode == "ACTIVE" || modelStatusCode == "SOLD_OUT" || (modelStatusCode == "READY_FOR_SALE" && modelSalePlannedPriceDispFlag == "Y")) && _partnerPriceYN == "Y" && _b2bRentalOnlyFlag == "N" }}' +
					'{{#if _isPartnerPriceShow}}'+
						'<a href="{{_pdpUrlPath}}" {{#if modelStatusCode == "SOLD_OUT" && partnerPrice > 0}} class="sold_out"{{/if}}>' +
							'<div class="price-info sales{{#if modelStatusCode == "SOLD_OUT" && partnerPrice > 0}} sold_out{{/if}}">' +
								'{{#if partnerPrice > 0}}'+
									'<div class="price-in">' +
										'<span class="price">{{vcui.number.addComma(partnerPrice)}}<em>원</em></span>' + 
									'</div>' +
								'{{/if}}' +
							'</div>' +
							'{{#if partnerPrice > 0}}'+
								'{{#if _obsCouponDiscountPrice > 0}}'+
									'<div class="price-info benefit">' +
										'<p class="benefit-price"><span class="txt">쿠폰할인가</span><em>{{vcui.comma(_obsCouponDiscountPrice)}}<span>원</span></em></p>' +
									'</div>' +
								'{{/if}}' +
							'{{/if}}' +
						'</a>' +
					'{{#else}}' +
	                    '<div class="price-info business-price-info">' +
	                    	'<a href="javascript:void(0)" data-contents="{{#raw modelDisplayName}} {{#raw sku}}">사업자회원가 보기</a>' +
		                    '<div class="tooltip-wrap srch-tooltip">' +
		                        '<button type="button"><span class="blind">자세히 보기</span></button>' +
		                        '<div class="tooltip-box">' +
		                            '<span class="title">사업자회원가</span>' +
		                            '<p>사업자몰에서는 사업자 회원 인증 후 사업자회원가, 쿠폰할인가 확인 및 구매가 가능합니다.</p>' +
		                            '<button type="button" class="btn-close"><span class="blind">닫기</span></button>' +
		                        '</div>' +
		                    '</div>' +
		                '</div>' +
					'{{/if}}'+
				'{{/if}}'+
				/* 내일배송 */
				'{{#if partnerPrice > 0 && modelStatusCode == "ACTIVE" && (deliveryTomorrowText || _delivTomorrowList.length > 0) }}'+
					'<div class="delivery-info">'+
						'{{#if deliveryTomorrowText && tomorrowFlag == "N"}}'+
							'<span>{{deliveryTomorrowText}}</span>'+
						'{{#else}}'+
							'{{#if _delivTomorrowList.length > 0 }}'+
								'<button type="button" data-href="#deliveryPopup1" data-control="modal" class="btn-delivery" data-delivery-info="{{_delivTomorrowList}}">내일배송</button>'+
							'{{/if}}'+
						'{{/if}}'+
					'</div>'+
				'{{/if}}'+
				'</div>' +
			'</div>' + // end .reslut-info
			'{{#if (modelStatusCode == "ACTIVE" || (modelStatusCode == "READY_FOR_SALE" && modelSalePlannedPriceDispFlag == "Y")) && _subscribePriceYN == "Y" }}' +
				'{{#if digitalData.userInfo.partnerType === "ENT"}}' +
					'<div class="info-subscribe">' +
						'<div class="subscribe-box">' +
						'<p class="txt">' +
							'<span class="badge-subscribe">구독가능</span>' +
							'<span><strong>{{subscribeYear}}</strong>년 구독시, </span>' +
							'<span>월<strong>{{vcui.number.addComma(subscribePrice)}}</strong>원</span>' +
						'</p>' +
						'<a href="{{_subscribeUrl}}" class="link-subscribe" data-contents="{{#raw modelDisplayName}} {{#raw sku}}"><span>월 구독하기</span></a>' +
						'</div>' +
					'</div>' +
				'{{#else}}' +
					'<div class="info-subscribe">' +
						'<div class="subscribe-box">' +
							'<p class="txt"><strong>지금 보는 제품, 구독하기</strong></p>' +
							'<a href="javascript:void(0)" class="link-subscribe link-subscribe-not-bizlogin" data-contents="{{#raw modelDisplayName}} {{#raw sku}}"><span>사업자회원 이용 요금보기</span></a>' +
						'</div>' +
					'</div>' +
				'{{/if}}' +
			'{{/if}}' +
			// div.result-tabs
			tempProductItemTab + 
		'</div>' +
	'</li>';

  // 문제해결
  // prettier-ignore
  var tempSupportItem = '<li>' +
      '<div class="item solution {{#if !isVideo}}no_video{{/if}}">' +
        '<div class="solution_tit"><a href="{{url}}">{{#raw title}}</a></div>' +
        '<div class="solution_flexarea">' +
          '<div class="solution_cnt">' +
            '<a href="{{url}}">' +
                '<span class="cnt_txt">{{#raw content}}</span>' +
            '</a>' +
            '<div class="solution_tag">' +
              '<div class="tag_itm">{{_categorys}}</div>' +
            '</div>' +
          '</div>' + 
          '{{#if isVideo && videoId}}<div class="solution_imgwrap">' +
            '<a href="{{url}}">' +
                '<div class="solution_img" style="background-image: url(\'//img.youtube.com/vi/{{videoId}}/default.jpg\')"></div>' +
            '</a>' +
          '</div>{{/if}}' +
        '</div>' +
      '</div>' +
    '</li>';

  // 이벤트/기획전
  // prettier-ignore
  var tempEventItem = '<li>' +
      '<a href="{{url}}?b2bYn=Y">' +
        '<div class="box event">' +
            '<div class="box_bgimg">' +
                '<img onerror="lgkorUI.addImgErrorEvent(this);" data-pc-src="{{_imageUrl}}" data-m-src="{{_imageUrl}}" alt="{{title}}">' +
            '</div>' +
            '<div class="box_cnt">' +
                '<ul class="box_lab">' +
                    '{{#each item in flag}}<li>{{item}}</li>{{/each}}' +
                '</ul>' +
                '<div class="box_name">{{#raw title}}</div>' +
                '<div class="box_date">{{_startDate}}~{{_endDate}}</div>' +
            '</div>' +
        '</div>' +
      '</a>' +
    '</li>';

  var linkHost =
    window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : ""; 

  var module = function () {
    $.extend(this, {
      variable: {
        data: null, // ajax res
        param: null, // ajax res param
        opts: {
          unit: "", // product || support ...
          sort: "", // best || date  ...
          moreUri: null, // 전체보기 ajax 호출 uri
          cartUri: null,
          initialList: true, // false 시 init()때 createList 실행 안함
          partnerType: null,
          partnerCd: null,
        },
        model: "",
        listTotal: null, // 카테고리 총 갯수
        areaIntersection: null, // area 옵저버
        moreIntersection: null, // more 옵저버
        isModal: false,
        page: {
          start: 1, // 시작 넘버
          end: 0, // 끝 넘버
          min: 0, // more 전 최소 노출 넘버
          increment: 30, // 한번에 증가 갯수
          count: 0, // 페이지 카운팅(more 횟수, 팝업은 열리면 1)
        },
        filterData: {},
        smartFilter: {},
        device: "",
        accoActivatedIndex: -1, // 아코디언 활성화된 index (product 전용)
      },
      event: {
        IS_LAST: "is_last", // more 마지막
        DONE: "done", // ajax 완료
        CHANGE_TAB: "change_tab", // 탭 변경 (product||noData 내에 탭)
        CHANGE_SCROLL_Y: "change_scroll_y", // 세로 스크롤 위치
        CHANGE_SCROLL_X: "change_scroll_x", // 가로 스크롤 위치
        CHANGE_PAGE: "change_page", // 스토리 탭 페이징 변경
        OPEN_ACCORDION: "open_accordion", // 아코디언 오픈
      },
      el: {
        $container: null, // 리스트 append 시킬 element
      },
      selector: {},

      gramFullUrl: {
          'www.lge.co.kr':'https://brand.lge.co.kr',
          'wwwstg.lge.co.kr':'https://brandstg.lge.co.kr', 
          'wwwdev50.lge.co.kr':'https://branddev.lge.co.kr', 
          'localhost':'https://branddev.lge.co.kr',
          'test.lge.co.kr':'',
      },
      handler: {
        /**
         * no img 처리 전에 카테고리별 기본 svg 일러스트 대체
         * @param {element} img 이미지 element
         * @param {string} cate 카테고리ID
         */
        addImgCateErrorEvent: function (img, cate) {
          var self = this;
          var middlePath = window.breakpoint.isMobile ? "mobile/" : "";

          var imgElm = document.createElement("img");
          var categoryId = cate || "";

          imgElm.src =
            "/kr/images/gnb/store/" + middlePath + categoryId + ".svg";

          imgElm.onload = function () {
            img.src = imgElm.src;
          };

          imgElm.onerror = function () {
            lgkorUI.addImgErrorEvent(img);
          };
        },

        /**
         * 비교하기 클릭 이벤트
         * @param {} e
         */
        compare: function (e) {
          var $target = $(e.currentTarget);
          var item = $target.closest(".compare_check").closest(".item");
          var data = item.data("ec-product") || {};
          var b2bcatemapping = item.attr("data-b2bcatemapping");
          var careType = item.attr("data-caretype");
          var categoryId = _.get(data, "category_id");
          var countTargetStorage = lgkorUI.getStorage(
            lgkorUI.COMPARE_KEY,
            categoryId
          );
          var compareCount =
            countTargetStorage && countTargetStorage.data.length
              ? countTargetStorage.data.length
              : 0;
          var limit = lgkorUI.getCompareLimit();
		  var lgecomOnlyFlag = item.attr("data-lgecomOnlyFlag");

          e.preventDefault();

          if (!categoryId) return;

          if ($target.prop("checked") && data) {
            var img = item.find(".result-thumb > a[href] > img");
            var src = img.attr("src") || "";
            var alt = img.attr("alt") || "";
            var path = img.parent().attr("href");

            var compareObj = {
              id: data.model_id,
              productName: data.model_name,
              productID: data.model_code,
              productImg: src,
              productAlt: alt,
              b2bcatemapping: b2bcatemapping,
              careType: careType,
              path: path,
			  lgecomOnlyFlag: lgecomOnlyFlag,
			  b2cYN: "N"
            };

            if (compareCount >= limit) {
              $target.prop("checked", false);
              $(window).trigger("toastshow", limit + "개까지 비교가능합니다.");
              return;
            }

            lgkorUI.addCompareProd(categoryId, compareObj, data.category_name);
          } else {
            lgkorUI.removeCompareProd(categoryId, data.model_id);
          }
        },

        /**
         * .open_win 에 대한 새창 열림
         * @param {*} e
         */
        openWindowPop: function (e) {
          var target = $(e.currentTarget);
          var url = target.data("url");

          e.preventDefault();

          if (url) {
            this.openWindowPop(url);
          }
        },
        
        /**
         * 사업자회원가 보기 클릭 이벤트
         * @param {} e
         */
        loginCheck: function (e) {
          var $target = $(e.currentTarget);
          e.preventDefault();

          var islogin = $("div.contents.search").attr("data-islogin") == "true" ? true : false;
          if (islogin) {
        	  var partnerType = $("div.contents.search").attr("data-partner-type");
        	  var bsnsMbrStat = $("div.contents.search").attr("data-bsnsMbrStat");
        	  if (partnerType == "B2C" && bsnsMbrStat == "WAIT") {
        		  $('#standby').vcModal('show'); 
        	  }else {
        		  $('#memberAuth').vcModal('show');
        	  }
          }else {
        	  $('#login').vcModal('show');
          }          
        },
      },
      setProperty: function () {
        var $container = this.el.$container;

        this.variable.isModal =
          $container.closest(".morelist-layer").length > 0;
      },
      bind: function () {
        // unbind
        var unitName = this.variable.opts.unit;

        $(window).off(".plpitem-" + unitName);
        this.el.$container.off(".plpitem");

        $(window).on(
          "breakpointchange.plpitem-" + unitName,
          this.breakpointChecker.bind(this)
        );

        // 세로 스크롤 이벤트 (팝업)
        if (this.variable.isModal) {
          this.el.$container
            .closest(".morelist-layer")
            .off("scroll.modal")
            .on(
              "scroll.modal",
              _.throttle(
                function (e) {
                  var scrollTop = $(e.currentTarget).scrollTop();

                  this.el.$container.trigger(this.event.CHANGE_SCROLL_Y, {
                    scrollY: scrollTop || 0,
                  });
                }.bind(this),
                1000
              )
            );
        }

        // 가로 스크롤 이벤트
        this.el.$container.on(
          "scroll.plpitem",
          _.throttle(
            function (e) {
              var scrollLeft = $(e.currentTarget).scrollLeft();

              this.el.$container.trigger(this.event.CHANGE_SCROLL_X, {
                scrollX: scrollLeft || 0,
              });
            }.bind(this),
            1000
          )
        );

        // 비교하기
        this.el.$container.on(
          "change.plpitem",
          ".compare_check input",
          this.handler.compare.bind(this)
        );

        // 새창 (일괄)
        this.el.$container.on(
          "click.plpitem",
          ".open_win",
          this.handler.openWindowPop.bind(this)
        );
        
        // 사업자회원가 보기
        this.el.$container.on(
          "click.plpitem",
          ".business-price-info a",
          this.handler.loginCheck.bind(this)
        );

		  // 구독버튼 사업자회원가 보기 : [BTOCSITE-86615] 사업자몰(B2B) 구독 도입
		  this.el.$container.on(
			  "click.plpitem",
			  ".info-subscribe .subscribe-box .link-subscribe-not-bizlogin",
			  this.handler.loginCheck.bind(this)
		  );
		  //// [BTOCSITE-86615] 사업자몰(B2B) 구독 도입
      },
      /**
       * 초기화
       * @param {object} result 데이터
       * @param {object} [options] 옵션
       * @param {string} [options.unit = ''] 카테고리 영문명
       * @returns
       */
      init: function (result, options) {
        var opts = $.extend(this.variable.opts, options);

        this.el.$container = $(opts.container);

        this.variable.param = result.param || {};

        this.setProperty();
        this.bind();

        this.setLayout();
        if (opts.initialList) this.createList(result);

        var hash = location.hash.replace("#", "");
        var savedData = lgkorUI.getStorage(hash);

        this.breakpointChecker(!savedData.uiState);
      }, 
      breakpointChecker: function (resetAcco) {
        var breakpoint = window.breakpoint;
        var resetAccordion = resetAcco === undefined ? resetAcco : true;
        var accordion = this.el.$container.data("ui_accordion") || {};

        this.variable.device = breakpoint.name;

        if (accordion && accordion.cid) {
          switch (breakpoint.name) {
            case "pc":
              accordion.off("accordionexpand");

              accordion.setOption("singleOpen", false);
              accordion.expandAll();

              break;
            case "mobile":
              accordion.on(
                "accordionexpand",
                function (e, data) {
                  var listIndex = data.index;
                  var tabIndex = data.content
                    .prev(".tabs-wrap")
                    .find("li.on")
                    .index();

                  // 아코디언 확장 시 해당 컨텐츠 대상으로 lazy 로드 // 모바일에서 초기에 아코디언 닫혀있다가 열었을 때 (tab change 일어나지 않으므로)
                  this.lazyload(data.content); 

                  this.triggerTabChange(listIndex, tabIndex);

                  this.variable.accoActivatedIndex = listIndex;
                }.bind(this)
              );

              accordion.on(
                "accordioncollapse",
                function (e, data) {
                  this.triggerTabChange(-1);
                }.bind(this)
              );

              // 탭 활성화 저장 데이터 존재하면 false // 재 진입 시 breakpoint 에 의한 아코디언 조작 없도록
              if (resetAccordion)
                this.accordionActivate(this.variable.accoActivatedIndex);
              
              break;
            default:
          }
        }
      },

      /**
       * 레이아웃 초기화
       */
      setLayout: function () {
        var $container = this.el.$container;
        var unitName = this.variable.opts.unit;

        $container.attr("data-unit", unitName);

        // 생성전 리스트 컨테이너 비움
        this.clear();
      },

      /**
       * 리스트 비움
       */
      clear: function () {
        var $container = this.el.$container;

        this.disposeMoreIntersection();

        this.addScrollEvent();

        $container.empty();
      },

      /**
       * 가로형 스크롤 이벤트 (e.g 이벤트 유닛)
       */
      addScrollEvent: function () {
        // 가로형 더보기 스크롤 이벤트
        this.el.$container
          .filter(".boxarea")
          .off("scroll.plpitem")
          .on(
            "scroll.plpitem",
            function (e) {
              var $target = $(e.currentTarget);

              // 4개 이상일 때만
              if (this.variable.listTotal <= 4) return;

              if (
                $target.scrollLeft() >=
                $target.get(0).scrollWidth - $target.get(0).offsetWidth
              ) {
                $target.off("scroll.plpitem");
                this.more({ min: this.el.$container.find("> li").length });
              }
            }.bind(this)
          );
      },

      /**
       * 검색 조건 따른 결과를 받아 최소 생성 (init() 에서 1회 실행, 팝업에선 실행 안함)
       * @param {object} result all ajax 호출 결과
       */
      createList: function (result) {
        // all res 에서 unit 데이터만 추출 this.variable.data 에 정의
        var data = (this.variable.data = result.data
          ? result.data[this.variable.opts.unit]
          : {});

        // 리스트 총 갯수
        this.variable.listTotal = _.get(data, "count", null);

        // 리스트 추가
        if (data.hasOwnProperty("data")) this.addList(data.data);
      },

      /**
       * 검색 조건 변경에 따른 결과만 받아 재 생성
       * @param {object} result unit ajax 호출 결과
       */
      changeList: function (result) {
        // 리스트 데이터, 카운트 교체
        if (this.variable.data) {
          _.set(this.variable.data, "data", result.data);
          _.set(this.variable.data, "count", result.count);
        }

        var data = this.variable.data;

        // 리스트 총 갯수 수정
        this.variable.listTotal = _.get(data, "count", null);

        // 리스트 비움
        this.clear();

        // 리스트 다시 추가
        if (data.hasOwnProperty("data")) this.addList(data.data);
      },
      /**
       * 더보기 & 팝업에 의한 자체 ajax 통신
       */
      callAjax: function () {
        var ajaxUrl = this.variable.opts.moreUri;

        if (!ajaxUrl) return;

        var postData = {
          unit: this.variable.opts.unit, // 고정값
          sort: this.variable.opts.sort, // init 최초받고 변경시 수정됨
          start: this.variable.page.start - 1, // incrementPage() 의해 상승
          end: this.variable.page.end - 1, // incrementPage() 의해 상승
          filterData: this.variable.filterData, // updateData() 의해 저장
          smartFilter: this.variable.smartFilter, // updateData() 의해 저장
          search: this.variable.param.search, // 특정 모델 검색에 이용 (팝업용)
          force: this.variable.param.force, // 고정값 (false시 result 에서 대체 키워드를 제공하지 않도록)
          partnerType: this.variable.opts.partnerType,
          partnerCd: this.variable.opts.partnerCd,
        };

        lgkorUI.requestAjaxDataPost(
          ajaxUrl,
          postData,
          function (result) {
            var data = result.data;

            // initialList: false 에 의해 초기 총갯수 정의 안되어 있을 때 대비 (e.g 팝업)
            if (this.variable.listTotal === null) {
              this.variable.listTotal = result.count;
            }

            var isLast = this.variable.listTotal <= this.variable.page.end;

            // 총갯수(listTotal)보다 로드하려는 로드 끝넘버(end)가 크면 end값 조정
            if (isLast) {
              this.updateData({
                end: this.variable.listTotal,
              });
            }

            // 전체보기 닫기 되었는데 로드되는 증상 막음 용도 // 박스형은 제외
            var $closeBtn = this.el.$container
              .next(".result-allview_area")
              .find(".result-allview.fixed");
            var isHorType = this.el.$container.hasClass("boxarea");

            if (!!$closeBtn.length && $closeBtn.is(":hidden") && !isHorType)
              return;

            this.addList(data);

            // infinite intersection
            if (isLast) {
              // 마지막 페이지
              this.el.$container.trigger(
                this.event.IS_LAST,
                this.variable.opts.unit
              );

              this.disposeMoreIntersection();
            } else {
              this.initMoreIntersection();
            }

            // 아코디언 재활성화
            if (this.variable.opts.unit === "product") {
              this.accordionActivate(this.variable.accoActivatedIndex);
            }

            // 콜백
            this.el.$container.trigger(this.event.DONE);
          }.bind(this),
          true
        );
      },

      /**
       * 리스트 추가 - 반복문에 의한 아이템 반복 생성
       * @param {Object} list
       */
      addList: function (list) {
        var $container = this.el.$container;
        var listHtmlTotal = 0;
        var listHtml = '';
        list.forEach(
          function (item, idx) {
            // add item
            if (this.variable.listTotal > idx) {
				//[최적화] 검색 리스트 렌더링
				listHtmlTotal++;
				listHtml += this.createItem(item, idx);
				if(list.length === listHtmlTotal){
				  $container.append(listHtml);
				  var moduleNames = $container.attr('ui-modules');
				  if( moduleNames && moduleNames.indexOf('LazyLoaderSwitch') > -1 ){
	                $container.vcLazyLoaderSwitch('instance').reload($container);
				  }else{
	                if(this.variable.opts.unit == 'product'){
	                  $('[data-unit=product]').vcLazyLoaderSwitch();
	                }else{
	                  $container.vcLazyLoaderSwitch();
	                }
				  }
				}
            }
          }.bind(this)
        );

        if (this.variable.opts.unit === "product" || this.variable.opts.unit === "noData") {
          this.initTab(); // 보이는 탭 일괄 초기화
        }
      },

	/**
	 * plp 아이템 생성
	 * @param {*} item 생성에 필요한 데이터
	 * @param {*} index
	 * @returns 생성된 마크업
	*/
	createItem: function (item, index) {
		var template = "";
		switch (this.variable.opts.unit) {
		case "noData": // 이런 제품 어떠세요?
		case "product":
			if (!item.hash) item.hash = [];

			// 판매코드.접미사코드 조합
			item._sku = item.salesModelCode + (item.salesSuffixCode ? "." + item.salesSuffixCode : "");

			var reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
			// element id로 활용
			item._id = item.sku.replace(reg, "");
			
			// pdp url // 렌탈 only ?dpType=careTab 추가
			item._modelUrlPath = linkHost + "/business" + item.modelUrlPath  ; 
			
			// 내일배송
			item.tomorrowFlag = _.defaultTo(item.tomorrowFlag, "N"); 
			
			// OnlyFlag
			item._lgcomOnlyFlag = _.defaultTo(item.lgcomOnlyFlag, "N");

			// 포인트
			item.couponFlag = _.defaultTo(item.couponFlag, "N");
			item.pointFlag = _.defaultTo(item.pointFlag, "N");
			item.giftFlag = _.defaultTo(item.giftFlag, "N");
			
			// 혜택
			item.newYearTextBadge = _.defaultTo(item.newYearTextBadge, ""); 
			item.deliveryTomorrowText = _.defaultTo(item.deliveryTomorrowText, ""); 
			item.prdBenefitInfo = _.defaultTo(item.prdBenefitInfo, {}); 

			// 스펙
			if (item.techSpecs) {
				item._specsStr = "";
				item.techSpecs.forEach(function (obj, index) {
					item._specsStr += "<span><em>" + obj.SPEC_NAME + "</em>" + obj.SPEC_VALUE_NAME + "</span>";
				});
			}

			// 리뷰
			item._hasReview = lgkorUI.stringToBool(item.hasReview);
			item.reviewContent = _.defaultTo(item.reviewContent, {});
			
			// 모바일용 아코디언 헤드 텍스트
			item._reviewPreview = _.get(item.reviewContent, "likePercent", 0);
			
			//partnerType[제휴사 타입](AFC:복지몰, AFF: 임직원몰, ENT:사업자, LGE:LG전자임직원, B2C:일반)
			item._isPartnerPriceShow = this.variable.opts.partnerType == "ENT" ? true :  false;
			item.partnerPrice = _.defaultTo(item.partnerPrice, "0");
			item._obsCouponDiscountPrice = 0;
			if (item.partnerPrice > 0 && item.prdBenefitInfo.obsCouponDiscountPrice && item.prdBenefitInfo.obsCouponDiscountPrice > 0) {
				item._obsCouponDiscountPrice = item.partnerPrice - item.prdBenefitInfo.obsCouponDiscountPrice;
			}			

			// 이미지 + 제품명 선택 판매처 있는 경우 
			item._pdpUrlPath =  item._modelUrlPath 
			
			// 제품명에 속성 값  노출
            item._keywdNmText = "";
            item._keywdNmText1 = "";
            var keywdNm = _.defaultTo(item.keywdNm, "");
            if(keywdNm != "") {
	            if (keywdNm.split("^").length > 1) {
	                item._keywdNms = keywdNm.split("^").map(function (elm, idx) {
	                  if (idx === 0) item._keywdNmText = elm.trim();
	                  if (idx === 1) item._keywdNmText1 = elm.trim();
	                });
	            } else {
	                item._keywdNmText = keywdNm;
	            }
            }
			
			// 고객지원
			item.support = _.defaultTo(item.support, []);
			item.support.forEach(function (obj, idx) {
				obj._isOne = !(obj.manualCnt > 1 || obj.driverCnt > 1);
				obj._imageUrl = linkHost + obj.imageUrl;
				obj._title = obj.title.replace(/<[^>]*>?/g, '');
			});
			if (_.get(item, "support[0].manual.title")) {
				// 메뉴얼 타이틀 문자열 가공 분리
				var path = "support[0].manual";
				var info = _.get(item, path + ".title").split(" - ");
				_.set(item, path + "._title", info[0]);
				if (info.length > 0) _.set(item, path + "._desc", info[1]);
			}
			// 고객지원 - 모바일용 아코디언 헤드 텍스트
			item._supportPreview = this.getSupportPreview(item.support);
			
			// 비교하기
			item.b2bCateMapping = _.defaultTo(item.b2bCateMapping, "");
			item.careType = _.defaultTo(item.careType, "");
			item._compareBtnState = this.getCompareBtnStatus(item);
			
			// 모델구분
			if (item.modelGubun == "1") {
				item._modelGubun = "일반제품";
			}else if (item.modelGubun == "2") {
				item._modelGubun = "묶음제품";
			}else if (item.modelGubun == "3") {
				item._modelGubun = "케어용품/소모품";
			}else if (item.modelGubun == "4") {
				item._modelGubun = "용역제품";
			}else if (item.modelGubun == "5") {
				item._modelGubun = "구독제품";
			}
			
			// 내일 배송
			var delivTomorrowList = _.defaultTo(item.deliveryTomorrowList, []);
			item._delivTomorrowList = delivTomorrowList.length > 0 ? JSON.stringify(delivTomorrowList) : delivTomorrowList;
			
			item.ga = this.makeProductGAData(item);
			
			item._imageUrl = linkHost + item.imageUrl;
			
			// 탭 id 값 구분을 위한
			item._index = this.el.$container.children().length + index;

			item._subscribeUrl = _.defaultTo(item.subscribeUrl, "");
			item._isSubscribeUrlExist = item._subscribeUrl === "" ? false : true;
			item._subscribeUrl = linkHost + "/business" + item._subscribeUrl  ;
			item._partnerPriceYN = _.has(item, 'partnerPriceYN')
				? item.partnerPriceYN
				: _.get(item, 'partnerPrice', 0) > 0 ? "Y" : "N";
			item._subscribePriceYN = _.has(item, 'subscribePriceYN')
				? item.subscribePriceYN
				: _.get(item, 'subscribePrice', 0) > 0 ? "Y" : "N";

			item._b2bRentalOnlyFlag = item.b2b_rental_only_flag || "N";

			template = tempProductItem;
			
			break;
          case "support":
            item._categorys = item.category.join(" > ");
            item.videoId = _.defaultTo(item.videoId, null);

            template = tempSupportItem;
            break;
          case "event":
            item._imageUrl = linkHost + item.imageUrl;
            item._startDate = item.startDate || "";
            item._endDate = item.endDate || "";
            template = tempEventItem;

            break;
          case "new":
            item._device = this.el.$container.data("device") || "";
            if (item.titlePc === "") item.titlePc = item.title;
            if (item.descriptionPc === "")
              item.descriptionPc = item.description;
            _.each(item.models, function (data) {
            	data._imageUrl = linkHost + data.imageUrl;
            	data._newSaleRate = (parseInt(((data.originalPrice - data.price) / data.originalPrice) * 100) || 0);
            	
            	// 제품명에 속성 값  노출
				data._keywdNmText = "";
				data._keywdNmText1 = "";
				var keywdNm = _.defaultTo(data.keywdNm, "");
				if(keywdNm != "") {
					if (keywdNm.split("^").length > 1) {
						data._keywdNms = keywdNm.split("^").map(function (elm, idx) {
							if (idx === 0) data._keywdNmText = elm.trim();
							if (idx === 1) data._keywdNmText1 = elm.trim();
						});
					} else {
						data._keywdNmText = keywdNm;
					}
				}
            });
            
            item._isFlag = item.isFlag.toLowerCase();
            item._type = item.type === "" ? "nor" : item.type;

            template = tempNew;

            break;
          case "manual":
              template = tempManual;

              if (_.get(item, "title")) {
                // 메뉴얼 타이틀 문자열 가공 분리
                var info = _.get(item, "title").split(" - ");
                _.set(item, "_title", info[0]);

                if (info.length > 0) _.set(item, "_desc", info[1]);
              }

              return vcui.template(template, { item: { manual: item } });
          case "driver":
              template = tempDriver;

              return vcui.template(template, { item: { driver: item } });            
          default:
        }

        return vcui.template(template, item);
      },

      /**
       * 탭 일괄 초기화
       */
      initTab: function () {
        // 탭 초기화 안된 것들 일괄 초기화
        var $tab = this.el.$container.find(
          ".result-tabs .tabs-wrap[ui-modules!='Tab']"
        );

        if ($tab.length) {
          // 탭 초기 셋팅
          $tab.each(
            function (idx, elm) {
              var $tabWrap = $(elm);
              $tabWrap.vcTab();

              var tabIns = $tabWrap.data("ui_tab");
              var idx = $tabWrap.find(".tabs li.on").eq(0).index() || 0;

              if (idx >= 0) {
                // 활성화 탭버튼이 있다면
                var $tabBtn = tabIns.$tabs.eq(idx).find("> a");
                var $tabCont = $(tabIns.$contents[idx]);

                // 탭 컨텐츠 활성화
                tabIns.select(idx); // 아래 tabchange 이벤트 발생 전 실행 (활성화만 스타일 변경 위한)

                // 탭 초기 셋팅 때 컨텐츠 전체 대상으로 lazy 로드
                this.lazyload($tabCont);

                this.changeAccordionHeader($tabBtn); // 모바일용 아코디언 해더 텍스트 교체
              } else {
                // 활성화 탭버튼이 없다면 탭 자체 숨김
                $tabWrap.hide();
              }
            }.bind(this)
          );

          // 탭 변경 이벤트
          $tab.on(
            "tabchange",
            function (e, data) {
              var $tabBtn = data.button;
              var $tabCont = data.content;
              var act = parseInt(data.selectedIndex);

              this.changeAccordionHeader($tabBtn); // 모바일용 아코디언 해더 텍스트 교체

              // 탭 클릭시 아코디언 활성화
              var accordion = $tabBtn
                .closest(".result-list")
                .data("ui_accordion");

              if (accordion) {
                var listIndex = $tabBtn.closest(".item").parent().index();
                accordion.expand(listIndex);

                this.triggerTabChange(listIndex, act);
              }

              // 탭 클릭 시 해당 컨텐츠 대상으로 lazy 로드
              this.lazyload($tabCont);
            }.bind(this)
          );

          // 모바일용 (하나열면 다른것 닫혀야 하기 때문에 대상을 리스트 전체를 잡음)
          if (!this.el.$container.data("ui_accordion")) {
            //ul.result-list
            this.el.$container.vcAccordion({
              itemClosest: "li",
              itemSelector: ">li",
              toggleSelector: " .cnt_mo_open, .tab_mo_close",
              contentSelector: ".tabs-contant",
              activeClass: "",
              singleOpen: true,
              useAnimate: false,
            });
          } else {
            // accordion 이미 초기화되어 있다면 상황에 맞게 활성화 (재검색 경우)
            this.accordionActivate();
          }
        }
      },

      /**
       * lazy 로드
       * @param {jQueryEelement} target 부모 컨텐츠
       * @param {string} selector lazy 적용할 선택자 수동 적용
       */
      lazyload: function (target, selector) {
        var lazyLoader = target.data("ui_lazyLoaderSwitch");

        if (lazyLoader) {
          lazyLoader.reload(target);
        } else {
          if (target.attr("id")) {
            target.vcLazyLoaderSwitch({
              selector: "#" + target.attr("id") + " ",
            });
          } else if (!!selector) {
            target.vcLazyLoaderSwitch({
              selector: selector + " ",
            });
          }
        }
      },

      /**
       * 상태 복구
       * @param {object} data
       */
      restore: function (data) {
        // 탭 상태 복구
        if (!_.isNil(data.listIndex) && !_.isNil(data.tabIndex)) {
          this.accordionActivate(data.listIndex);
        }

        // 가로 스크롤 복구
        if (!_.isNil(data.scrollX)) {
          this.el.$container.scrollLeft(data.scrollX);
        }
      },

      /**
       * 제품탭 아코디언 상황에 맞게 활성화 (모바일)
       * @param {number} act -1: 전부 닫힘, undefined: getActivate().index || -1
       */
      accordionActivate: function (act) {
        // tab content 부모(.tabs-contant) display에 영향이 있기에 모바일에서만
        // pc에서 실행 시 탭 .tabs-contant display:none 처리되어 tab 컨텐츠 안보임 주의
        if (this.variable.device !== "mobile") return;

        var accordion = this.el.$container.data("ui_accordion") || {};

        if (accordion && accordion.cid) {
          if (act >= 0 || act === -1) {
          } else {
            // 인자 없으면 아코디언 이전 활성화, 그것도 없으면 -1 (전부 닫힘)
            act =
              accordion.getActivate().index >= 0
                ? accordion.getActivate().index
                : -1;
          }

          accordion.collapseAll();
          accordion.setOption("singleOpen", true);

          if (act >= 0) {
            setTimeout(
              function () {
                accordion.expand(act);

                this.el.$container.trigger(this.event.OPEN_ACCORDION);
              }.bind(this),
              10
            ); // collapseAll 후 딜레이 줘야 먹힘, accordion.js 에도 있음
          }
        }
      },

      /**
       * 아코디언 타이틀 변경 함수(모바일)
       * @param {jQueryEelement} $tabBtn
       */
      changeAccordionHeader: function ($tabBtn) {
        var act = parseInt($tabBtn.attr("href").substr(-1)) - 1;
        var $accHeaderSPAN = $tabBtn
          .closest(".result-tabs")
          .find("> .cnt_mo_default span.cnt_mo_txt");

        $accHeaderSPAN.hide().eq(act).show();

        // 아코디언 버튼 영역에 달린 리뷰 영역 show / hide
        // 실제 노출될 수 있는 첫번째 아코디언 타이틀 span
        var firstSPAN = $accHeaderSPAN
          .filter(function () {
            return $(this).children().length > 0;
          })
          .eq(0);
        var firstIdx = firstSPAN.index();

        var $accHeaderReview = $accHeaderSPAN.filter(".review"); // 리뷰 타이틀 span
        var $accHeaderReviewCont = $accHeaderReview.siblings(".cnt_mo_review"); // 버튼 영역에 달린 리뷰

        if (!$accHeaderReview.length || firstIdx === -1) return;

        // 맨 앞 탭의 타이틀일 때 && 리뷰가 맨앞이 아닐 때 달린 리뷰 show
        if (act === firstIdx && $accHeaderReview.index() !== firstIdx) {
          $accHeaderReviewCont.show();
        } else {
          $accHeaderReviewCont.hide();
        }
      },

      /**
       * tab 변경 이벤트 외부 호출
       * @param {*} listIndex
       * @param {*} tabIndex
       */
      triggerTabChange: function (listIndex, tabIndex) {
        this.el.$container.trigger(this.event.CHANGE_TAB, {
          listIndex: listIndex,
          tabIndex: tabIndex || 0,
        });
      },

      /**
       * 제품 내 스토리 페이징 변경 이벤트 외부 호출
       * @param {*} id
       * @param {*} page
       * @param {*} scrollX
       */
      triggerPageChange: function (id, page, scrollX) {
        this.el.$container.trigger(this.event.CHANGE_PAGE, {
          id: id,
          page: page,
          scrollX: scrollX || 0,
        });
      },

      /**
       * instance 저장을 위한 target 반환
       * @returns
       */
      getTarget: function () {
        return this.el.$container;
      },
      
      /**
       * 모바일용 아코디언 해더 고객지원 텍스트 가공 함수
       * @param {Object} arr support 데이터
       */
      getSupportPreview: function (arr) {
        var driverCnt = _.sum(_.map(arr, "driverCnt"));
        var manualCnt = _.sum(_.map(arr, "manualCnt"));

        var returnValue = "";
        if (manualCnt) {
          returnValue +=
            "<span><em>제품사용설명서</em> " + manualCnt + "</span>";
        }
        if (driverCnt) {
          returnValue += "<span><em>드라이버 S/W</em> " + driverCnt + "</span>";
        }

        return returnValue;
      },
      
      /**
       * 유닛명 반환
       * @returns
       */
      getUnit: function () {
        return _.get(this.variable.opts, "unit", "");
      },
      /**
       * 유닛 한글로 반환
       * @returns
       */
      getUnitNameKor: function () {
        return _.get(this.variable.data, "unitName", "");
      },
      /**
       * unit별 표현 가능한 총 갯수 반환
       * @returns
       */
      getTotalCount: function () {
        return this.variable.listTotal;
      },

      /**
       * 파라미터 정보 반환
       * @returns
       */
      getParam: function () {
        return this.variable.param;
      },

      /**
       * 페이징 정보 반환
       * @returns
       */
      getPageInfo: function () {
        return this.variable.page;
      },

      /**
       * 비교하기 버튼 상태 변경
       * @param {object} item 제품 데이터
       * @returns
       */
      getCompareBtnStatus: function (item) {
        var categoryId = item.categoryId;
        var storageCompare = lgkorUI.getStorage(
          lgkorUI.COMPARE_KEY,
          categoryId
        );

        var showing = true;
        
        if (item.modelStatusCode == "DISCONTINUED"  || item.modelStatusCode == "SUSPENDED") { // 단종, 삭제
            showing = false;
        }else if (item.compareAvailYn == "N") {//compareAvailYn 값으로 변경
            showing = false;
        }else if (categoryId === "") {
        	showing = false;
        }else if (_.result(storageCompare, "data.length")) {
            var data = _.get(storageCompare, "data[0]");
            showing = data.b2bcatemapping === item.b2bCateMapping;
        }

        return showing;
      },

      /**
       * 전체보기
       * @param {object} data
       */
      more: function (data) {
        // 기본 더보기 전 페이징 시작값 설정
        this.variable.page.start = 1;
        this.variable.page.min = _.get(data, "min", 0); // 노출된 li 갯수가 min 됨
        this.variable.page.end = this.variable.page.min; // end도 동일하게 설정
        this.variable.page.count = _.get(data, "count", 0); // 화면 복구에서 사용됨

        if (this.variable.opts.moreFun) {
          this.incrementPage(); // 페이징 +1

          // 필터 데이터 추출을 위해 외부 호출, 이후 plp.callAjax(postData) 호출 됨
          this.variable.opts.moreFun({
            unit: this.variable.opts.unit,
            isMore: true,
          });
        }
      },

      /**
       * 전체보기 닫기
       */
      close: function () {
        this.disposeMoreIntersection();

        this.el.$container
          .find("> li")
          .eq(this.variable.page.min - 1)
          .nextAll()
          .remove();

        this.el.$container.get(0).scrollIntoView({ block: "center" });

        if (this.variable.opts.unit === "product") {
          var accordion = this.el.$container.data("ui_accordion") || {};

          if (accordion && accordion.cid) {
            // 닫기로 제거한 리스트에 아코디언 활성화가 있었을 경우(index : -1)
            if (accordion.getActivate().index < 0) {
              this.accordionActivate();
            }
          }
        }
      },

      /**
       * 데이터 업데이트 ( 전체보기, 재진입, 팝업정렬 변경 상황에 사용 )
       * @param {object} data
       */
      updateData: function (data) {
        if (data.count) this.variable.page.count = data.count;
        if (data.start) this.variable.page.start = data.start;
        if (data.end) this.variable.page.end = data.end;

        if (data.filterData) this.variable.filterData = data.filterData;
        if (data.smartFilter) this.variable.smartFilter = data.smartFilter;

        if (data.sort) this.variable.opts.sort = data.sort;
      },

      /**
       * 페이지 정보 증가
       */
      incrementPage: function () {
        this.variable.page.count += 1; // 1 more up

        var isHorType = this.el.$container.hasClass("boxarea");
        var increment = !isHorType
          ? this.variable.page.increment // 그외 30개 쪼개서 call
          : this.variable.listTotal; // box 형은 한번에 call

        this.variable.page.start = this.variable.page.end + 1; // e.g) 5, 31..
        this.variable.page.end = this.variable.page.count * increment; // e.g) 30, 60 ...
      },

      /**
       * more intersection 적용
       */
      initMoreIntersection: function () {
        this.disposeMoreIntersection(); // 기존 more intersection 제거

        this.variable.moreIntersection = new IntersectionObserver(
          function (target) {
            if (target.length) {
              if (target[0].isIntersecting) {
                this.incrementPage(); // 페이징 +1
                this.callAjax(); // ajax 호출
              }
            }
          }.bind(this),
          {}
        );

        // 추가 로드 임계값
        var threshold = Math.floor(this.variable.page.increment * 0.5);

        // observe 대상
        var $target = this.el.$container.find(
          "> li:nth-last-child(" + threshold + ")"
        );

        // 팝업인 경우
        if (this.variable.isModal) {
          // observe 대상 마지막 li로 변경
          $target = this.el.$container.find("> li").last();
        }

        if ($target.length) {
          // increment 절반 직전에서 li 에서 more intersection
          this.variable.moreIntersection.observe($target.get(0));
        }
      },

      /**
       * more intersection 해제
       */
      disposeMoreIntersection: function () {
        if (this.variable.moreIntersection) {
          this.variable.moreIntersection.disconnect();
          this.variable.moreIntersection = null;
        }
      },

      makeProductGAData: function (item) {
        var param = {
			brand: "LG",
			category: item.superCategoryName + "/" + item.categoryName + "/" + item.subCategoryName,
			ct_id: item.categoryId || "",
			discounted_price: item._obsCouponDiscountPrice > 0 ? "" + item._obsCouponDiscountPrice : "",
			model_category: item.categoryName,
			model_gubun: item._modelGubun,
			model_id: item.modelId,
			model_name: item.modelDisplayName,
			model_sku: item.salesModelCode + (item.salesSuffixCode ? "." + item.salesSuffixCode : ""),
			model_sub_category: item.subCategoryName,
			model_super_category: item.superCategoryName,
			price: item.partnerPrice > 0 ? "" + item.partnerPrice : "",
			// 이하 key값 비교하기에 필요해 추가
	        model_code: item.salesModelCode || "",
	        category_id: item.categoryId || "",
	        category_name: item.categoryName || "",
        };
        return JSON.stringify(param);
      },

      // 문자열 전체 공백제거 함수
      removeSpaces: function (val) {
        return val.replace(/\s+/g, "");
      },

      // background 용 이미지 url 치환
      fixedBgEncodeURI: function (str) {
        return encodeURI(str).replace(/[()]/g, function (c) {
          return "%" + c.charCodeAt(0).toString(16);
        });
      },

      /**
       * 매장 정보 윈도우 팜업
       * @param {String} url 새창 띄울 url
       */
      openWindowPop: function (url) {
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        var width = windowWidth < 1070 ? windowWidth : 1070;

        if (isApp() && vcui.detect.isIOS) {
          var jsonString = JSON.stringify({
            url: "https://" + window.LGEAPPHostName + url,
            command: "openInAppBrowser",
          });
          webkit.messageHandlers.callbackHandler.postMessage(jsonString);
        } else {
          void window.open(
            linkHost + url,
            "_blank",
            "width=" +
              width +
              ", height=" +
              windowHeight +
              ", scrollbars=yes, location=no, menubar=no, status=no, toolbar=no"
          );
        }
      },
    });
  };

  return function () {
    var ins = new module();

    // public (throws)
    return {
      init: function () {
        ins.init.bind(ins).apply(this, arguments);

        $.extend(this, {
          event: ins.event,
          getTarget: ins.getTarget.bind(ins),
          getUnit: ins.getUnit.bind(ins),
          getUnitNameKor: ins.getUnitNameKor.bind(ins),
          getTotalCount: ins.getTotalCount.bind(ins),
          getParam: ins.getParam.bind(ins),
          getPageInfo: ins.getPageInfo.bind(ins),
          changeList: ins.changeList.bind(ins),
          updateData: ins.updateData.bind(ins),
          callAjax: ins.callAjax.bind(ins),
          more: ins.more.bind(ins),
          close: ins.close.bind(ins),
          clear: ins.clear.bind(ins),
          restore: ins.restore.bind(ins),
        });

        ins.getTarget().data("instance", this);
      },
    };
  };
})();